import cn from 'classnames';
import PropTypes from 'prop-types';

export const StepHeader = ({ step, title, subtitle, className }) => (
  <div
    className={cn(
      'flex flex-col gap-3 py-6 px-7 bg-white rounded-t-2xl text-text-primary font-sans',
      className,
    )}>
    <p className="m-0 text-2xl font-normal leading-8 text-grey-50 font-sans">Step {step}</p>
    <h1 className="m-0 text-[28px] font-semibold leading-9 text-text-primary font-heading">
      {title}
    </h1>
    {subtitle && (
      <p className="m-0 text-2xl font-normal leading-8 text-grey-50 font-sans">{subtitle}</p>
    )}
  </div>
);

StepHeader.propTypes = {
  step: PropTypes.oneOf([1, 2, 3]).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  className: PropTypes.string,
};
